import { DropdownMenuItem } from '@neo/primitives/dropdown-menu'
import { downloadFile } from '@shared/utils'
import { Download } from 'lucide-react'
import { useFlowId } from '../../../hooks/use-flow-id'
import { useVibeAgentStore } from '../store'

export const VibeDebugDownloadButton = () => {
  const { id: phloId } = useFlowId()

  const handleDownloadChat = () => {
    const { transcript, runStatus, sessionId } = useVibeAgentStore.getState()

    const debugData = {
      meta: {
        phloId,
        sessionId,
        runStatus,
        exportedAt: new Date().toISOString(),
      },
      transcript,
    }

    const blob = new Blob([JSON.stringify(debugData, null, 2)], {
      type: 'application/json',
    })
    const fileName = `vibe-agent-debug-${phloId ?? 'new'}-${sessionId ?? 'no-session'}-${Date.now()}.json`
    downloadFile('', fileName, blob)
  }

  return (
    <DropdownMenuItem onClick={handleDownloadChat} data-testid="menu-download-debug">
      <Download className="w-4 h-4 mr-2" />
      Download Debug Data
    </DropdownMenuItem>
  )
}
